// SPDX-License-Identifier: AGPL-3.0-or-later

import {
	boostedVoiceVolumePercentToTrackVolume,
	clampVoiceVolumePercent,
} from '@app/features/voice/utils/VoiceVolumeUtils';

export function computeNativeParticipantVolume(args: {
	userVolumePercent: number;
	outputVolumePercent: number;
	locallyMuted: boolean;
}): number {
	if (args.locallyMuted) return 0;
	const composedPercent =
		(clampVoiceVolumePercent(args.userVolumePercent) / 100) * clampVoiceVolumePercent(args.outputVolumePercent);
	const gain = boostedVoiceVolumePercentToTrackVolume(clampVoiceVolumePercent(composedPercent));
	return Math.max(0, Math.min(2, gain));
}
